import { createLazyBlock } from 'mangojuice-lazy';
import ViewPlaceholder from './View/placeholder';
import importWithRetry from 'mz-utils/importWithRetry'


export default createLazyBlock({
  resolver: () => importWithRetry(() => import('./')),
  loadingView: ViewPlaceholder
});
